// Công tắc màn "Kênh nhân sự" (luồng kenh_nhan_su của máy chủ) giữ ở kho nhỏ để
// cổng menu — hàm thường, không gọi hook được — đọc đồng bộ. Nạp bởi
// useStaffChannelFlagSync (api.ts) ở useSidebarData. Tệp này KHÔNG nhập máy
// khách API: cổng menu còn chạy trong kịch bản dựng bộ hướng dẫn (node).
import { create } from "zustand";

interface StaffChannelFlagState {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
}

export const useStaffChannelFlag = create<StaffChannelFlagState>((set) => ({
  enabled: false,
  setEnabled: (enabled) => set({ enabled }),
}));
